const decodeHtml = (html) => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = html || "";
  return textarea.value;
};

export default decodeHtml;
